import { VideoProject } from "@/services/bedrock";
import {
  VIDEO_PROJECT_STATUS_COLUMNS,
  VideoProjectStatusColumnDef,
  VideoProjectStatusColumnId,
  getRepresentativeStatusForColumn,
  getStatusColumnId,
} from "@/components/VideoProjectStatusPicker/columns";

export type KanbanColumnId = VideoProjectStatusColumnId;
export type KanbanColumnDef = VideoProjectStatusColumnDef;

export const KANBAN_COLUMNS = VIDEO_PROJECT_STATUS_COLUMNS;
export const getKanbanColumnId = getStatusColumnId;
export { getRepresentativeStatusForColumn };

export function isKanbanCardDraggable(status: VideoProject.Status): boolean {
  return status !== VideoProject.Status.POSTED && status !== VideoProject.Status.POST_FAILED;
}
